// src/components/Testimonials.js
import React, { useEffect, useState } from 'react';
import styles from '../App.module.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Ratings from './ratings';

const Testimonials = () => {
  const [testinomials, setTestinomials] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseurl = process.env.REACT_APP_API_BASE_URL;
  const fetchClientsTestinomials =async() => {
    try {
      const response = await fetch(`${baseurl}get-testinomials.php`);
      const result = await response.json();
      setTestinomials(result.data); // Adjust based on your API response  
      setLoading(false);      
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);      
    } finally {}
  };
  useEffect(() => {
    fetchClientsTestinomials();
  }, [])

  // const ArrowLeft = (props) => (
  //   <button style={{background:"red", color: 0}} {...props} className={'prev'}>
  //     back
  //   </button>
  // );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    autoplaySpeed: 2000,
  };
  return (
    <>
      {
        loading ? (
          <div className="animate-pulse bg-slate-500 w-full">
            <div className="w-full bg-slate-500 py-5">
              <h2 className="text-6xl font-bold mb-0 text-white uppercase d-flex align-items-center justify-content-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" fill="currentColor" className={`bi bi-quote text-yellow-400 ${styles.testinomail_icon}`} viewBox="0 0 16 16">
                  <path d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388q0-.527.062-1.054.093-.558.31-.992t.559-.683q.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 9 7.558V11a1 1 0 0 0 1 1zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612q0-.527.062-1.054.094-.558.31-.992.217-.434.559-.683.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 3 7.558V11a1 1 0 0 0 1 1z"/>
                </svg>
                Our<br/> Testimonials
              </h2>
              <div className="flex justify-center">              
                <div className="w-full md:w-2/3 lg:w-1/2 p-3 bg-gray-300 rounded dark:bg-gray-700">
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 w-full rounded mb-2"></div>
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 w-5/6 rounded mb-2"></div>
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 w-full rounded mb-2"></div>
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 w-1/3 rounded mb-4"></div>
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 w-1/4 rounded mb-2"></div>
                  <div className="h-4 bg-gray-200 dark:bg-slate-400 w-1/4 rounded mb-2"></div>
                </div>              
              </div>
            </div>
          </div>
        ):(
          <section id="testimonials" className="py-10 bg-dark" data-aos="fade-up">
            <div className="container">
              <div className="row">
                <div className="col-md-12">          
                  <h2 className="text-6xl font-bold mb-0 text-white uppercase d-flex align-items-center justify-content-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" fill="currentColor" className={`bi bi-quote text-yellow-400 ${styles.testinomail_icon}`} viewBox="0 0 16 16">
                      <path d="M12 12a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1h-1.388q0-.527.062-1.054.093-.558.31-.992t.559-.683q.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 9 7.558V11a1 1 0 0 0 1 1zm-6 0a1 1 0 0 0 1-1V8.558a1 1 0 0 0-1-1H4.612q0-.527.062-1.054.094-.558.31-.992.217-.434.559-.683.34-.279.868-.279V3q-.868 0-1.52.372a3.3 3.3 0 0 0-1.085.992 4.9 4.9 0 0 0-.62 1.458A7.7 7.7 0 0 0 3 7.558V11a1 1 0 0 0 1 1z"/>
                    </svg>
                    Our<br/> Testimonials
                  </h2>
                </div>
              </div>
              <div className="row">
                <div className={`col-md-12 ${styles.Testimonials_slider}`}>
                  <div className="flex justify-center">
                    <div className="w-full md:w-2/3 lg:w-1/2">
                      <Slider {...settings}>
                        {
                          testinomials.map((item, index)=>
                            <div className="item" key={index}>
                              {/* <p className="mb-0 text-white d-flex align-items-center">5.0 
                                <div className='ms-2 d-flex align-items-center'>                            
                                  <Ratings classes="w-3 h-3 text-yellow-400 cursor-pointer ms-1" rarings="4.5"/>
                                </div>
                                <span className='d-inline bg-white' style={{width:"35px",height:"1px",marginInline:"5px"}}></span>
                                {testinomials.length} Review
                              </p> */}
                              <div className="mb-0 text-white text-xl" dangerouslySetInnerHTML={{ __html: item.testinomials}}/>
                              <p className="font-semibold text-yellow-400 mb-0">{item.author}</p>
                              <p className="mb-0 text-white">{item.company}</p>
                            </div>
                          )
                        }                                  
                      </Slider>            
                    </div>
                  </div>
                </div>
              </div>        
            </div>
          </section>
        )
      }
    </>
  );
}

export default Testimonials;
